const baseAuthorCRUDModels = [
  'authors', 'view-author',
  'message',
  'teams', 'view-team',
  'arc-teams', 'view-arc-team',
  'arcs', 'view-arc', 'cancel-arc-claim', 'claim-arc', 'review-arc',
  'your-arcs',
  'books', 'view-book',
  'gamification', 'rank'
]

export default abstract class ReviewerRole {
  // CRUD operation permissions
  read: string[] = baseAuthorCRUDModels

  arcDownloadsPerWeek = 3
  totalClaimOverdueDayAllowance = 10
  arcMaxDownloads = 10
  requiredReviewsForTier = 0
  requiredReviewRateForTier = 30
  canMessageAuthor = false
  canDownloadAudioBookArcs = true
}
